module.exports = __webpack_public_path__ + "img/129.c01ad304.gif";